import { useLang } from "@/i18n";
import { useSEO } from "@/hooks/useSEO";
import { Reveal, ChapterHeading } from "@/components/Reveal";

export default function PoliciesPage() {
    const { t } = useLang();
    useSEO(t.policies.title, t.policies.desc);
    return (
        <div className="pt-28 pb-24 md:pt-36 md:pb-32" data-testid="policies-page">
            <div className="mx-auto max-w-3xl px-6 md:px-12">
                <ChapterHeading label={t.policies.label} title={t.policies.heading} />
                <div className="mt-12 space-y-10">
                    {t.policies.sections.map((s, i) => (
                        <Reveal key={i} delay={i * 0.06}>
                            <section data-testid={`policy-section-${i}`}>
                                <h2 className="font-display text-2xl font-medium tracking-tight text-ink">{s.h}</h2>
                                <p className="mt-3 text-base font-light leading-relaxed text-ink-muted">{s.p}</p>
                            </section>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    );
}
